import { __ } from '@wordpress/i18n';

/**
 * Remaining capacity value the API uses to mean "no capacity limit".
 */
export const UNLIMITED_CAPACITY = -1;

/**
 * Get the default "spots left" text used when the field has no custom text.
 *
 * Full-day services lead with the label because the message describes the whole
 * selected range rather than a single time slot.
 *
 * @param isFullDay Whether the service books in full-day blocks.
 */
export const getDefaultSpotsLeftText = (isFullDay = false): string => {
	return isFullDay
		? __('[[Spots|Spot]] left: {spots}', 'gp-bookings')
		: __('{spots} [[spots|spot]] left', 'gp-bookings');
};

/**
 * Format the "spots left" message for a remaining capacity.
 *
 * Supports the `{spots}` placeholder for the number and `[[plural|singular]]`
 * for conditional text.
 *
 * @param remainingSlots Remaining capacity.
 * @param spotsLeftText  Custom text from the field settings, or null for the default.
 * @param isFullDay      Whether the service books in full-day blocks.
 */
export const formatSpotsLeftText = (
	remainingSlots: number,
	spotsLeftText?: string | null,
	isFullDay = false
): string => {
	const template = spotsLeftText || getDefaultSpotsLeftText(isFullDay);

	return template
		.replace(/{spots}/g, String(remainingSlots))
		.replace(/\[\[([^|]+)\|([^\]]+)\]\]/g, (_match, plural, singular) =>
			remainingSlots === 1 ? singular : plural
		);
};
